import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PHOTO_LIBRARY } from "../../data/photoLibrary";

const ease = [0.22, 1, 0.36, 1];

export const CollectionEditorial = () => (
  <section className="py-24 md:py-40" data-testid="collection-editorial">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease }}
        className="md:col-span-6 relative overflow-hidden aspect-[4/5] border border-line bg-stone"
      >
        <img
          src={PHOTO_LIBRARY.laceSleeveChampagne.url}
          alt="Nancy inspecting lace detail on a gown in the studio"
          className="img-zoom w-full h-full object-cover object-center"
        />
      </motion.div>

      <div className="md:col-span-5 md:col-start-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease }}
        >
          <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-5">The Atelier</p>
          <h2 className="font-serif font-semibold text-4xl md:text-5xl leading-[1.05] tracking-tight mb-6">
            Every piece, made <span className="italic">to order</span>
          </h2>
          <p className="text-ink/80 leading-relaxed mb-4">
            Nothing here is pulled from a rack. Each gown is designed, cut and sewn by Nancy in her
            Perth atelier — lace placed, beading set and seams finished entirely by hand.
          </p>
          <p className="text-ink/80 leading-relaxed mb-10">
            Choose a silhouette as your starting point, then shape it around you across a series of
            fittings until it feels unmistakably yours.
          </p>
          <Link
            to="/process"
            data-testid="collection-editorial-link"
            className="group inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] border-b border-ink pb-2 transition-colors hover:text-champagne hover:border-champagne"
          >
            See the process
            <ArrowRight size={16} strokeWidth={1.5} className="transition-transform duration-500 group-hover:translate-x-1" />
          </Link>
        </motion.div>
      </div>
    </div>
  </section>
);
